// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import App from './App';
// import * as serviceWorker from './serviceWorker';
// import { BrowserRouter } from 'react-router-dom';
// import { Provider } from 'react-redux';

// import store from './store1';

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render (
//     <Provider store={store}>
//         <BrowserRouter>
//             <App />
//         </BrowserRouter>
//     </Provider>
// );

// serviceWorker.unregister();

  // src/index.js
import React, { useEffect, useState, useMemo, createContext } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import '../src/assets/css/eventflow.css';
import './assets/css/global.css';
import store from './store';
import router from './router';

import { lightTheme, darkTheme } from './theme';
import { ColorModeContext } from './context/ColorModeContext';

export { ColorModeContext };

const root = ReactDOM.createRoot(document.getElementById('root'));

function Root() {
  // ✅ CHANGE 2: 'light'
  const [mode, setMode] = useState('light');

  useEffect(() => {
    document.body.classList.toggle('dark-mode', mode === 'dark');
  }, [mode]);

  const colorMode = useMemo(
    () => ({
      mode,
      toggleColorMode: () =>
        setMode((prev) => (prev === 'light' ? 'dark' : 'light')),
    }),
    [mode]
  );

  const theme = useMemo(
    () => (mode === 'light' ? lightTheme : darkTheme),
    [mode]
  );

  return (
    <Provider store={store}>
      <ColorModeContext.Provider value={colorMode}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <RouterProvider router={router} />
        </ThemeProvider>
      </ColorModeContext.Provider>
    </Provider>
  );
}

root.render(<Root />);